import OrderStrategy from "./OrderStrategy";

export const NoLimit = OrderStrategy(0, "edi.orders.add_order.order_lifecycle.goods_quantity_strategy.select.0");
export const SumLimit = OrderStrategy(1, "edi.orders.add_order.order_lifecycle.goods_quantity_strategy.select.1");
